import Env from './env'
import Channels from './channels'
import Swup from 'swup';
import SwupGiaPlugin from '@swup/gia-plugin';
import SwupJsPlugin from '@swup/js-plugin';
import SwupBodyClassPlugin from '@swup/body-class-plugin';
// import SwupGaPlugin from '@swup/ga-plugin';
import SwupPreloadPlugin from '@swup/preload-plugin';
import SwupProgressPlugin from '@swup/progress-plugin';
import SwupScrollPlugin from '@swup/scroll-plugin';
// import SwupGtagPlugin from 'swup-gtag-plugin';
import { enableScroll,disableScroll } from '../common/ScrollDisabler';

window.tmTransition = false

export function EmbraceTheFlame(components) {
  const swup = new Swup({
    plugins: [
      new SwupBodyClassPlugin(),
      new SwupGiaPlugin({firstLoad: true,log:false,components: components}),
      new SwupPreloadPlugin(),
      // new SwupProgressPlugin(),
      // new SwupOverlayTheme(),
      // new SwupGtagPlugin({
      //   gaMeasurementId: window.GTAG_ID
      // }),
      new SwupScrollPlugin({
        doScrollingRightAway: false,
        animateScroll: false
      }),
      new SwupJsPlugin([
        {
          from: '(.*)',
          to: '(.*)',
          in: function(next,infos) {

            const statusMainnav = Env.framework.mainnav.getStatus()
            Env.framework.TRANSITIONS.setTitle(document.title);
            if(statusMainnav == true) {
              Env.framework.mainnav.close(
                ()=>{
                  Env.$html.classList.add('transition-byMenu')
                },
                ()=>{
                  // Env.framework.TRANSITIONS.setTransitionViewVisible()
                  // Env.framework.TRANSITIONS.out(
                  //   null,
                  //   ()=>{
                      Env.framework.TRANSITIONS.in(
                        ()=>{
                          setTimeout(() => {
                            next();
                          }, 2500);
                        },
                        ()=>{
                          clearTimeout(tmTransition)
                          tmTransition = setTimeout(() => {
                            Env.$html.classList.remove('transition-byMenu')
                          }, 3000);

                          enableScroll()
                        }
                      )
                    // }
                  // )
                }
              )
            } else {
              Env.framework.TRANSITIONS.in(
                null,
                ()=>{
                  enableScroll()
                  next();
                }
              )
            }

          },
          out: (next,infos) => {

            const statusMainnav = Env.framework.mainnav.getStatus()
            Env.framework.TRANSITIONS.setTransitionViewVisibleNoTween()
            disableScroll()
            if(statusMainnav == true) {
              next();
            } else {
              Env.framework.TRANSITIONS.out(
                ()=>{

                },
                ()=>{
                  next();
                }
              )
            }

          }
        }
      ])
    ]
  });

  swup.on('willReplaceContent',()=>{
    Channels.emit('statechange::before')
    // Env.framework.toolbox.resetScroll()
  })

  swup.on('contentReplaced',()=>{
    Channels.emit('statechange::ready')
  })

  swup.on('transitionEnd',()=>{
    Channels.emit('transition::end')
    Channels.emit('statechange::finalize')
  })

}
